export default __webpack_public_path__ + "static/green-screen-fisher-price-5c7d92b50068105b91b422a891e2ab51.jpg";